import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  signupUser: "",
  signupUserToken: "",
  adsUserDetails: "",
  isOpenEmailChangeModal: false,
  isOpenEmailVerificationModal: false,
  isOpenProfileCreateModal: false,
  isSubscriber: false,
};

const AdsUserReducer = createSlice({
  name: "AdsUserReducer",
  initialState: initialState,
  reducers: {
    setSignupUser: (state, { payload }) => {
      return {
        ...state,
        signupUser: payload,
      };
    },
    setAdsUserDetails: (state, { payload }) => {
      return {
        ...state,
        adsUserDetails: payload,
      };
    },
    openEmailChangeModal: (state, { payload }) => {
      return {
        ...state,
        isOpenEmailChangeModal: true,
        signupUser: payload,
      };
    },

    openSubscriber: (state, { payload }) => {
      return {
        ...state,
        isSubscriber: true,
      };
    },

    doneSubcriber: (state, { payload }) => {
      return {
        ...state,
        isSubscriber: false,
      };
    },

    openEmailVerificationModal: (state, { payload }) => {
      return {
        ...state,
        isOpenEmailVerificationModal: true,
        signupUser: payload?.user,
        signupUserToken: payload?.token,
      };
    },

    openProfileCreateModal: (state, { payload }) => {
      return {
        ...state,
        isOpenProfileCreateModal: true,
        // signupUser: payload,
      };
    },

    closeProfileCreateModal: (state) => {
      return {
        ...state,
        isOpenProfileCreateModal: false,
        // userData: {},
      };
    },

    closeEmailVerificationModal: (state) => {
      return {
        ...state,
        isOpenEmailVerificationModal: false,
        signupUser: "",
        signupUserToken: "",
      };
    },
    closeEmailChangeModal: (state) => {
      return {
        ...state,
        isOpenEmailChangeModal: false,
        // userData: {},
      };
    },
    clearAdsUserDetails: (state) => {
      return {
        ...state,
        adsUserDetails: "",
      };
    },
    clearSignupUser: (state) => {
      return {
        ...state,
        signupUser: "",
      };
    },
  },
});

export default AdsUserReducer;
